import { graphql } from '../../__generated__';

export const TRANSFER_CULTX_WINE = graphql(`
  mutation TransferInventoryOut($assetUnitIds: [String!]!) {
    transferInventoryOut(assetUnitIds: $assetUnitIds)
  }
`);
